(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  console.log('Log')
  window.storeLocatorConfig = {
      apiUrl: "{{ section.settings.api_url }}",
      apiKey: "{{ section.settings.api_key }}"
  };

  } catch(e) { console.error(e); }
})();
})();
